import React from 'react'
import './DashboardDataTable.less'

const DashboardDataTable = ({ children }) => {
  return (
    <div className="DataTableGrid__item">
      <div className="DataTable">{children}</div>
    </div>
  )
}

export default DashboardDataTable
